<template>
  <FaIcon v-if="isIcon" :icon-class="iconClass" :classes="classes" />
  <Default v-else :el="el" />
</template>
<script setup lang="ts">
import type { HTMLElementSimplified } from '@/components/components/cms/wysiwyg/types';
import FaIcon from '@/components/fa-icon.vue';
import Default from './default.vue';

const props = defineProps({
  el: {
    type: Object as PropType<HTMLElementSimplified>,
    required: true,
    default: () => ({}) as HTMLElementSimplified,
  },
});

const elClasses = props.el.attributes['class']?.split(' ');
if (elClasses?.length && elClasses[0].startsWith('icon')) {
  elClasses.shift();
}
const isIcon =
  elClasses?.length &&
  elClasses[0].startsWith('fa') &&
  elClasses[1].startsWith('fa');
const iconClass = isIcon ? `${elClasses[0]} ${elClasses[1]}` : '';
const classes = isIcon ? elClasses.slice(2).join(' ') : '';
</script>
